import { BackendModel, BackendService } from '../core/backend.service';
import { OperationalParametric } from '../cliente/operationalParametric.model';
import { Cliente } from '../cliente/cliente.model';
import { User } from '../security/user/user.model';
import { Acuerdo } from '../acuerdo/acuerdo.model';
import { ProductoPedido } from './producto-pedido.model';
import { Subcliente } from '../cliente/subcliente.model';
import { DescuentoPedido } from './pedido-details/descuento-pedido.model';
import { Pais } from '../security/user/pais.model';
import { ClienteSimplificado } from '../cliente/models/cliente-simplificado.model';


export class Pedido extends BackendModel {

  static path = '/new-pedidos/';

  usuarioAprobador: User;
  usuarioCliente: Subcliente;
  clienteSimplificadoDto: ClienteSimplificado; 
  tipoDePago: string;
  acuerdo: Acuerdo;
  numero: number;
  estado: OperationalParametric;
  fecha: string;
  fechaAprobacion: string;
  observaciones: string;
  direccion: string;
  nombreEnvio: string;
  tipoEnvioCosto: number;
  tipoEnvioDetalle: string;
  email: string;
  telefono: string;
  comprobante: string;
  transferenciaAprobada: Boolean;
  transferenciaDni:string;
  razonSocialTransferencia:string;
  productos: ProductoPedido[];
  costoEnvio: number;
  descuentoPedido: DescuentoPedido;
  precioFinal: number;
  tbEspecial: Boolean = false;
  pais: Pais;

}



// WEBPACK FOOTER //
// ./src/app/pedido/pedido.model.ts